module.exports = __webpack_public_path__ + "7b7855597bc27b12d6bf5c55e8b42f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Assets/pizza.png
// module id = 1345
// module chunks = 0